import _ from 'underscore';

export function T_(text, vars) {
  if (typeof vars === 'undefined' || !vars) {
    return text;
  }
  let result = _.template(text)(vars);
  const oldsettings = _.templateSettings;
  _.templateSettings = {
    evaluate: /<\[([\s\S]+?)\]>/g,
    interpolate: /<\[=([\s\S]+?)\]>/g,
    escape: /<\[-([\s\S]+?)\]>/g,
  };
  result = _.template(result)(vars);
  _.templateSettings = oldsettings;
  return result;
}
